export const environment = {
    production: false,
    env: 'dev',
    apiUrl: 'https://dev.crownwash.com/',
    gaMeasurementId: 'G-NMCBE6KJBK',
    assetsUrl: 'https://assets.crownwash.com'
};
